import type React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { TemplateProfileImage } from '@xing-com/crate-lebenslauf-components';
import {
  type HeaderFontSize,
  getTemplateHeaderFontSize,
} from '@xing-com/crate-lebenslauf-helpers';
import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';

import { CreativeBackground } from '../assets/background';

type HeaderProps = {
  pageIndex: number;
};

const Container = styled.div`
  height: calc(220px - var(--pageMarginTop));
`;
const Name = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 220px;
  width: 100%;
  padding-left: var(--pageMarginLeft);
  padding-top: 40px;
`;
const NameField = styled.div<HeaderFontSize>`
  font-family: 'IBM Plex Sans';
  font-weight: 700;
  font-size: ${(props) => props.$fontSize}px;
  line-height: ${(props) => props.$fontSize + 11}px;
  color: var(--color-textHeader);
`;
const Tag = styled.div`
  position: absolute;
  width: 158px;
  height: 34px;
  left: 0;
  top: 177px;
  background: var(--mainColor);
  border-top-right-radius: 17px;
  border-bottom-right-radius: 17px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
  color: #e6f1f1;
  font-family: 'IBM Plex Sans';
  font-weight: 700;
  font-size: 16px;
`;

export const ProfilePicture = styled(TemplateProfileImage)`
  position: absolute;
  border-radius: 50%;
  left: 359px;
  top: 38px;
`;

export const Header: React.VFC<HeaderProps> = ({ pageIndex }) => {
  const { cv, fileAttachments } = useReadVitaReactiveVariable();
  const intl = useIntl();
  const lebenslauf = intl.formatMessage({ id: 'CRATE_VITA_TEMPLATE_TAG' });

  if (!cv || pageIndex > 0) return <></>;

  const firstName = cv.personalInformation?.firstName;
  const lastName = cv.personalInformation?.lastName;
  const fontSize = getTemplateHeaderFontSize({
    textLength: Math.max(firstName?.length || 0, lastName?.length || 0),
    resizeAfterIndex: 8,
    max: 34,
    min: 14,
  });

  return (
    <Container>
      <CreativeBackground />
      <Name>
        <NameField {...fontSize}>{firstName}</NameField>
        <NameField {...fontSize}>{lastName}</NameField>
      </Name>
      <Tag>{lebenslauf}</Tag>
      <ProfilePicture
        fileAttachments={fileAttachments}
        width="172"
        height="172"
      />
    </Container>
  );
};
